// files are bytes: 10(mb) * 1024 * 1024 = 10485760
import { i18n } from '@/packages/i18n';

const ACCEPTED_FILE_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
const ACCEPTED_FILE_SIZE = 10485760;

export default function useFileInputValidations() {
  const isFileTypeAllowed = (file) => {
    const { t } = i18n.global;

    return (!ACCEPTED_FILE_TYPES.includes(file.type)
      ? t('FileUploadField.error.fileTypeErrorMsg')
      : '');
  };
  const isSingleFileSizeInLimits = (file) => {
    const { t } = i18n.global;

    return (file.size > ACCEPTED_FILE_SIZE
      ? t('FileUploadField.error.fileSizeErrorMsg')
      : '');
    };

  const areMultiFileSizesInLimits = (files) => {
    const { t } = i18n.global;

    const totalFileSizes = Object.keys(files).reduce(
      (acc, file) => files[file].size + acc,
      0,
    );
    return totalFileSizes > ACCEPTED_FILE_SIZE
      ? t('MultiFileUploadField.error.fileSizeLimitErrorMsg')
      : '';
  };

  const areMultiFileTypesAllowed = (files) => {
    const { t } = i18n.global;

    const fileTypeAllowed = (fileType) => ACCEPTED_FILE_TYPES.includes(fileType.type);
    const fileTypeNotAllowed = !Object.values(files).every(fileTypeAllowed);

    return fileTypeNotAllowed
      ? t('MultiFileUploadField.error.fileTypesAllowedErrorMsg')
      : '';
  };

  return {
    isFileTypeAllowed,
    isSingleFileSizeInLimits,
    areMultiFileSizesInLimits,
    areMultiFileTypesAllowed,
    ACCEPTED_FILE_TYPES,
  };
}
